<template>
  <div id="selectpet-species" class="mt-2">
    <b-overlay :show="loader" rounded="sm">
      <div class="container mb-3 ">
        <center>
          <h3 for="">
            <strong class="text-danger my-3"></strong>PLEASE SELECT YOUR PET
          </h3>
          <span v-if="button" class="pet-select-species-error-text text-danger"
            >*Please select a Pet</span
          >
        </center>
        <label class="wrap my-5 col-md-12">
          <select
            name=""
            class="form-control noBorder"
            id=""
            v-model="selected_species"
          >
            <option value="">--Select your pet--</option>
            <option :value="species" v-for="species in species">{{
              species.pet_name
            }}</option>
          </select>
        </label>
        <div class="mt-3 mb-3" slot="modal-footer">
          <div class="row d-flex justify-content-between">
            <div class="col-md-4 "></div>
            <div class="col-md-4">
              <button class="btn btn-danger float-right col-md-6" @click="next">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <img
            src="@/assets/site/images/Govava_Wait_icon.gif"
            alt=""
            class=""
          />
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: "SelectSpecies",
  props: [""],
  data() {
    return {
      species: [],
      selected_species: "",
      button: false,
      loader: true,
      type: null,
    };
  },
  created() {
    this.getAllSpecies();
    this.type = this.$store.state.pet_image;
  },
  methods: {
    getAllSpecies() {
      this.loader = true;
      var token = localStorage.getItem("userData");
      var userdata_array = JSON.parse(token);
      var api_token = userdata_array.user.api_token;
      var fetch_url = process.env.VUE_APP_URL + "customer/pet/getSpecies";
      fetch(fetch_url, {
        method: "get",
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Authorization: "Bearer " + api_token,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          this.species = data.species;
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
        });
    },
    next() {
      if (!this.selected_species) {
        this.button = true;
      } else {
        if (this.type == null) {
          this.$store.state.pet_image = this.selected_species.pet_icon;
        }
        this.$emit("speciesToBreed", this.selected_species);
      }
    },
    prev() {},
  },
};
</script>

<style>
.pet-select-species-error-text {
  display: block;
  margin-top: 8px;
  font-size: 16px;
  font-weight: 500;
}
</style>
